import gsap from 'gsap';
import imagesLoaded from 'imagesloaded';
import RytmWebflow from 'rytm-webflow'
import { initASwap } from './aswap';

export const initLoading = () => {
  const imgLoad = imagesLoaded("img", onImagesLoaded);
  animateCookietermsBox();
}
const onImagesLoaded = () => {
  const box = document.querySelector(".box-loading");
  if (!box) {
    onLoadingComplete();
  }
  gsap.to (".box-loading svg", {
    y: "100vh",
    duration: .8,
    delay: 1,
    ease: "power3.inOut",
    onComplete: onLoadingComplete
  });
  gsap.to(".box-loading .loading-bg", {
    opacity: 0,
    duration: .2,
    delay: 2,
  });
}

const onLoadingComplete = () => {
  setTimeout(() => {
    RytmWebflow.aswap.clearCache();
    document.documentElement.classList.remove("index-loading");
  }, 400);
  initASwap();
}

// cookieterms box
const animateCookietermsBox = () => {
  gsap.set('.cookieterms-inner', { y: "150%", opacity: 1 });
  gsap.to('.cookieterms-inner', {
    y: "0%",
    duration: 1.2,
    delay: 1,
    ease: "power3.inOut"
  });
}